import { render, staticRenderFns } from "./RubberPendant.vue?vue&type=template&id=2208bf0c&scoped=true&"
import script from "./RubberPendant.vue?vue&type=script&lang=js&"
export * from "./RubberPendant.vue?vue&type=script&lang=js&"
import style0 from "./RubberPendant.vue?vue&type=style&index=0&id=2208bf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208bf0c",
  null
  
)

component.options.__file = "RubberPendant.vue"
export default component.exports